import PrimeBadge from "../../../../../../components/primeBadge/PrimeBadge";
import TextWrapper from "../../../../../../components/textWrapper/TextWrapper";
import styles from "./displayAllPlayers.module.css";

const DisplayAllPlayers = ({ allPlayers }) => {
  const displayPlayers = allPlayers.map((player, index) => {
    return (
      <div
        className={styles.player}
        key={player?._id || player?.userId || player?.gameId || index}
      >
        <div className={styles.playerName}>
          <TextWrapper textStyle={"textSmall"}>
            اسم اللاعب: {player.name}
          </TextWrapper>
          <PrimeBadge isPrime={player?.isPrime} primeTier={player?.primeTier} size="small" />
        </div>
        <div className={styles.playerGameInfo}>
          <div className={styles.gameNameWrapper}>
            <TextWrapper textStyle={"textSmall"}>
              الاسم في اللعبه : {player.gameName}
            </TextWrapper>
          </div>
          <div className={styles.gameIdWrapper}>
            <TextWrapper textStyle={"textMid"}>
              الايدي في اللعبه : {player.gameId}
            </TextWrapper>
          </div>
        </div>
      </div>
    );
  });

  return <div className={styles.container}>{displayPlayers}</div>;
};

export default DisplayAllPlayers;
